<template>
<div class="jingle" >
  <div class=" jingle_content container">
    <h1>Jingle</h1>
    <p>
      Téléchargez le Jingle pour l'inclure dans vos projets.
    </p>
    <div class="row">
      <div class="col-lg-6 col-md-12 col-sm-12">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/OJvz0Lfe8-4" frameborder="0" allowfullscreen></iframe>
      </div>
      <div class="download_jingle col-lg-6 col-md-12 col-sm-12">
        <div class="download_block">
          <p>
            <a href="/static/video/LogoImacJingle.mp4" download="LogoImacJingle">Vidéo (.mp4)</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
  export default {
    name: 'jingle'   
  }
</script>
<style lang="scss">
  /*FONTS
  **
  */
  @font-face {
    font-family: 'Poppins-Regular';
    src: url('../assets/fonts/Poppins-Regular.ttf');
  }

  .jingle h1, 
  .jingle h2, 
  .jingle h3, 
  .jingle p {font-family: 'Poppins-Regular';}

  .jingle p {font-size: 16px}

  .jingle{ 
    height: 100vh;
    background-image: url("../assets/bkg/gplaypattern.png"); 
  }

  .jingle_content{ 
    height: 100%;
    background: rgba(255,255,255,0.4); 
    padding-bottom: 20px;
  }

  .download_jingle { padding-top: 120px; }

  .download_jingle p { 
    padding-top: 10px;
    padding-bottom: 20px; 
  }

  a  {
    color: #333;
    text-decoration: none;
  }
  a:hover {
    color:#595959;
    text-decoration: none;
  }

  a:focus {
    color:#808080;
    text-decoration: none;
  }

  iframe{padding-left: 15px;}

</style>



// WEBPACK FOOTER //
// Jingle.vue?2a114d16